export enum ComplianceStatus {
  NO_DATA = -1,
  COMPLIANT = 0,
  NON_COMPLIANT = 1,
  AT_RISK = 2,
}

export const ComplianceStatusLabel: Record<ComplianceStatus, string> = {
  [ComplianceStatus.NO_DATA]: 'No Data',
  [ComplianceStatus.COMPLIANT]: 'Compliant',
  [ComplianceStatus.NON_COMPLIANT]: 'Non-Compliant',
  [ComplianceStatus.AT_RISK]: 'At Risk',
};

export const ComplianceStatusCodeMap: Record<
  ComplianceStatus,
  ComplianceStatus
> = {
  [ComplianceStatus.NO_DATA]: ComplianceStatus.NO_DATA,
  [ComplianceStatus.COMPLIANT]: ComplianceStatus.COMPLIANT,
  [ComplianceStatus.NON_COMPLIANT]: ComplianceStatus.NON_COMPLIANT,
  [ComplianceStatus.AT_RISK]: ComplianceStatus.AT_RISK,
};

export function getComplianceStatusFromCode(code: number): ComplianceStatus {
  return (
    ComplianceStatusCodeMap[code as ComplianceStatus] ??
    ComplianceStatus.NO_DATA
  );
}
